// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rSyoI","delete":"styles_delete__tyaNI","update":"styles_update__3yIuz","add":"styles_add__2E886"};